import React from 'react';

export const ErrorComponent = (props: any) => (
  <div className="text-danger">{props.msg}</div>
);
